import React, { } from 'react';
import { toast } from 'react-toastify';

interface Props {
  type: 'success' | 'error' | 'warn' | 'info';
  message: string;
}

const Toast = ({ type, message }: Props) => {
  switch (type) {
    case 'success':
      toast.success(<div style={{ display: 'flex', alignItems: 'center' }}> {message}</div>);
      break;
    case 'error':
      toast.error(<div style={{ display: 'flex', alignItems: 'center' }}> {message}</div>);
      break;
    case 'warn':
      toast.warn(<div style={{ display: 'flex', alignItems: 'center' }}> {message}</div>);
      break;
    case 'info':
      toast.info(<div style={{ display: 'flex', alignItems: 'center' }}> {message}</div>);
      break;
  }
};

export default Toast;